import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGenericQuery } from '../../../core/api/reactQuery';
import {
    LOCAL_STORAGE_KEY_ACCESS_TOKEN,
    setLocalStorage,
} from '../../../core/commom/localStorage';
import { populateDataLayerGA } from '../../../core/gtm';
import { useAccessControlStore } from '../../../core/stores/accessControlStore';
import { requestMe } from '../queries/fetchAuth';
import { useUserStore } from '../stores/authStore';
import useGetUserHistory from '../../../core/hooks/useGetUserHistory';

export function useMe(redirectOnFail = true) {
  const navigate = useNavigate();

  const { setUser } = useUserStore();
  const { setPermissions, setIsFreeUser } = useAccessControlStore();
  const { mutate: getUserHistory } = useGetUserHistory();
  
  const { data, isLoading, isSuccess } = useGenericQuery(
    ['me'],
    requestMe,
    setUser
  );

  if (isSuccess) {
    const newToken = data.access_token;

    setLocalStorage(LOCAL_STORAGE_KEY_ACCESS_TOKEN, newToken);
  }

  useEffect(() => {
    if (isSuccess && data) {
      if (data.situation === 'guest' && redirectOnFail) {
        navigate('/logout');
        window.location.reload();
      }

      const { modulesGranted } = data.permissions || {};
      setPermissions(modulesGranted);

      if(modulesGranted.includes('universitario-navegacao-livre-free')) {
        setIsFreeUser(true);
        getUserHistory()
      }

      populateDataLayerGA(data);
    }
  }, [isSuccess, data]);

  return {
    data,
    isLoading,
  };
}
